import { Typography } from "@mui/material";

const infoHeadTitleList: any[] = [
  {
    headTitle: (
      <>
        <Typography>施設名称</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>施設種類</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>情報更新日</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>従業状況</Typography>
      </>
    ),
  },
];

export { infoHeadTitleList };
